import { render, staticRenderFns } from "./clarifier.vue?vue&type=template&id=ece49638&scoped=true&"
import script from "./clarifier.vue?vue&type=script&lang=js&"
export * from "./clarifier.vue?vue&type=script&lang=js&"
import style0 from "./clarifier.vue?vue&type=style&index=0&id=ece49638&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece49638",
  null
  
)

export default component.exports